import styled, { keyframes } from "styled-components";
import btnMenuResponsive from "../../assets/icons/btn_menu.svg";
import { primaryColor } from "../../config/constants";
import { responsiveMenuIndex } from "../../config/zIndex";
import { fadeInDown } from "react-animations";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const HeaderContainer = styled.header`
  width: 100%;
  height: 58px;
  display: flex;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  position: relative;
`;

export const Menu = styled.nav`
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media (max-width: 910px) {
    width: 85%;
    position: initial;
  }
`;

export const BtnShowMenu = styled.button`
  width: 38px;
  height: 36px;
  display: none;
  background: url(${btnMenuResponsive});
  border: none;
  outline: none;
  cursor: pointer;

  @media (max-width: 910px) {
    display: flex;
  }
`;

export const BtnShowMenuResponsive = styled.button`
  width: 38px;
  height: 36px;
  display: none;
  background-color: ${primaryColor};
  border: none;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  position: absolute;
  top: 14px;
  left: 20px;

  @media (max-width: 910px) {
    display: flex;
  }
`;

export const CloseImg = styled.img`
  width: 38px;
  height: 36px;
`;

export const ResponsiveMenu = styled.div`
  padding: 18px 0 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${responsiveMenuIndex};
  animation: 0.5s ${fadeInDownAnimation};

  @media (min-width: 910px) {
    display: none;
  }
`;

export const ResponsiveNavigation = styled.div`
  margin-top: 60px;
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const RespBtnLogout = styled.button`
  height: 35px;
  font-size: 14px;
  font-weight: bold;
  color: ${primaryColor};
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const Navigation = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  flex: 1;
  min-width: 0;

  @media (max-width: 910px) {
    display: none;
  }
`;

export const ShowHospitalDiv = styled.div`
  margin-left: 10px;
  margin-right: 20px;

  padding-left: 10px;
  height: 35px;
  border-left: 1px solid #b3b3b3;

  display: flex;
  flex-direction: column;

  min-width: 0;
  max-width: 220px;

  @media (max-width: 910px) {
    position: absolute;
    left: 80px;
    display: ${({ active }) => (active ? "flex" : "none")};
  }
`;

export const HospitalText = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #808080;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClinicianText = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #cdcdcd;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClinicalInvestigationContainer = styled.div`
  width: calc((100% - 900px) / 2);
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  left: 20px;

  @media (max-width: 1170px) {
    display: none;
  }
`;

export const ClinicalInvestigationText = styled.p`
  font-size: 13px;
  line-height: 1.2;
  font-weight: bold;
  color: #808080;
`;

export const LngLogoutContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const BtnLogout = styled.button`
  margin-left: 20px;
  padding-left: 20px;
  height: 35px;
  font-size: 14px;
  font-weight: bold;
  color: ${primaryColor};
  border: none;
  outline: none;
  border-left: 1px solid #b3b3b3;
  background: transparent;
  cursor: pointer;

  @media (max-width: 910px) {
    display: none;
  }
`;